import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { NavPageTitle } from './nav-page-title';

@Component({
  selector: 'app-nav-page',
  template: `<ng-template>
    <ng-content select="[app-nav-page-error]"></ng-content>
    <div *ngIf="navPageTitle" class="flex flex-col gap-3">
      <ng-content select="[app-nav-page-title]"></ng-content>
      <ng-content select="[app-nav-page-subtitle]"></ng-content>
    </div>
    <ng-content></ng-content>
  </ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavPage {
  @Input() navLink?: string;
  @Input() navBack: boolean = true;
  @Input() headerAction?: TemplateRef<any>;
  @ContentChild(NavPageTitle, { static: true }) navPageTitle?: NavPageTitle;
  @ViewChild(TemplateRef, { static: true }) content!: TemplateRef<any>;
}
